import React from 'react';

class BoostForm extends React.Component {

    constructor(props) {
        super(props);
        this.onProductIdChange = this.onProductIdChange.bind(this);
        this.onScoreChange = this.onScoreChange.bind(this);
        this.onPost = this.onPost.bind(this);
        this.state = {
            productId: '',
            score: ''
        }
    }

    onProductIdChange(e) {
        this.setState({
            productId: e.target.value
        })
    }

    onScoreChange(e) {
        this.setState({
            score: e.target.value
        })
    }

    onPost() {
        this.props.onBoost(this.state);
    }

    render() {
        return (<div>
            <div className='row'>
                <div className='col-md-4'>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <label className="input-group-text" htmlFor="productId">ProductId: </label>
                        </div>
                        <input type="text"
                            className="form-control"
                            aria-label="product id"
                            onChange={ this.onProductIdChange }
                            value={ this.state.productId }></input>
                    </div>
                </div>
                <div className='col-md-4'>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <label className="input-group-text" htmlFor="productId">Score: </label>
                        </div>
                        <input type="text"
                            className="form-control"
                            aria-label="product id"
                            onChange={ this.onScoreChange }
                            value={ this.state.score }></input>
                    </div>
                </div>
                <div className='col-md-2'>
                    <button className='btn btn-info' onClick={this.onPost}>BOOST</button>
                </div>
            </div>
        </div >)
    }
}

export default BoostForm;